import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './weekly_demand_report.routes';
import moment from 'angular-moment';
import DailyMaxDemandPowerService from '../../../components/api/daily_max_demand_power/daily_max_demand_power.service';
import DemandPowerService from '../../../components/api/demand_power/demand_power.service';
import DailyWeatherService from '../../../components/api/daily_weather/daily_weather.service';
import WeatherService from '../../../components/api/weather/weather.service';
import CompareWeatherLogic from '../../../components/logic/compare_weather/compare_weather.logic';
import Chart from '../../../components/directive/chart/chart.directive';
import DateUtil from '../../../components/logic/date_util/date_util.module';
import CsvUtil from '../../../components/logic/csv_util/csv.util';
import PowerFormatter from '../../../components/logic/power-formatter/power-formatter.logic';
import chartConfig from './weekly_demand_report.config';

export class WeeklyDemandReportController {
  /*@ngInject*/
  constructor($stateParams, $filter, $state, $q, moment, PowerFormatter, DailyMaxDemandPowerService, DemandPowerService, DateUtil, CsvUtil, DailyWeatherService, WeatherService, CompareWeatherLogic) {
    this.id = $stateParams.id;
    this.$filter = $filter;
    this.$state = $state;
    this.$q = $q;
    this.moment = moment;
    this.DailyMaxDemandPowerService = DailyMaxDemandPowerService;
    this.DemandPowerService = DemandPowerService;
    this.DailyWeatherService = DailyWeatherService;
    this.WeatherService = WeatherService;
    this.CompareWeatherLogic = CompareWeatherLogic;
    this.PowerFormatter = PowerFormatter;
    this.DateUtil = DateUtil;
    this.CsvUtil = CsvUtil;

    this.startDate = this.DateUtil.beginningOfWeek(new Date());
    this.endDate = this.DateUtil.leapDate(this.startDate, 6);
    this.maxDate = this.startDate;

    this.categories = [];
    this.Week = ['日', '月', '火', '水', '木', '金', '土'];
    this.downloadFileName = 'demand_power_daily.csv';
    this.bulkDownloadFileName = 'demand_power_hourly.csv';
    this.bulkCsvGenerator = () => {
      return this.createBulkCsv();
    };
    this.downloading = false;

    this.chartConfig = chartConfig(this);
  }

  $onInit() {
    this.parentComponent.saConfigPromise.then(config => {
      let contract_powers = [];
      let limit_powers = [];
      let target_powers = [];
      for (let i = 0; i < 8; i++) {
        contract_powers.push(config.contract_power);
        limit_powers.push(config.limit_power);
        target_powers.push(config.target_power);
      }

      this.chart.series[1].setData(target_powers);
      this.chart.series[2].setData(limit_powers);
      this.chart.series[3].setData(contract_powers);

      this.updateGraph(this.startDate, this.endDate);
    });
  }

  updateGraph(startDate, endDate) {
    this.categories = [];
    for (let i = 0; i < 7; i++) {
      let utc = this.DateUtil.localToUTC(startDate);
      this.categories.push(this.DateUtil.leapDate(utc, i).valueOf());
    }
    const query = angular.extend({
      id: this.id,
      sa_config_id: this.id
    }, this.DateUtil.getDateRangeQueries(startDate, endDate));

    this.$q.all([
      this.DailyMaxDemandPowerService.show(query).$promise,
      this.DailyWeatherService.api.index(query).$promise
    ]).then(responses => {
      const powers = responses[0];
      const weathers = responses[1];

      this.chart.xAxis[0].setCategories(this.categories);

      this.demandPowerObjects = this.PowerFormatter.formatDailyDemandPowers(powers.powers, this.categories);
      this.demandPowers = this.demandPowerObjects.map(power => {return power.y});

      this.weathers = this.CompareWeatherLogic.compareDaily(weathers, this.categories);
      const y = (this.weathers.length > 0) ? 50 : null;

      this.chart.xAxis[0].update({
        labels: {y: y}
      });

      this.itemWidth = 100 / 7;

      this.csvData = this.CsvUtil.processMaxDemandPower(this.demandPowers, this.categories, this.weathers);
      this.chart.series[0].setData(this.demandPowerObjects);
      this.chart.reflow();
      this.maxPower = Math.max.apply(null, this.demandPowers);

      const date = this.moment(startDate);
      this.downloadFileName = date.format('[demand_power_]YYYY-MM-DD[_week_daily.csv]');
      this.bulkDownloadFileName = date.format('[demand_power_]YYYY-MM-DD[_week_hourly.csv]');
    });
  }

  createBulkCsv() {
    this.downloading = true;
    let startDate = this.moment(this.startDate);
    let endDate = this.moment(this.endDate).add(1, 'day');
    const powerQuery = angular.extend({id: this.id}, this.DateUtil.datetimeRangeQuery(startDate, endDate));
    const weatherQuery = angular.extend({sa_config_id: this.id}, this.DateUtil.getDateRangeQueries(startDate, endDate.subtract(1, 'day')));

    return new Promise(resolve => {
      this.$q.all([
        this.DemandPowerService.show(powerQuery).$promise,
        this.WeatherService.api.index(weatherQuery).$promise
      ]).then(responses => {
        resolve(this.CsvUtil.processBulkDemandPower(responses[0].powers, responses[1]));
        this.downloading = false;
      });
    });
  }

  changeDate(diff) {
    this.startDate = this.DateUtil.leapDate(this.startDate, diff);
    this.endDate = this.DateUtil.leapDate(this.startDate, 6);

    this.updateGraph(this.startDate, this.endDate);
  }

  getWeek(timeValue) {
    return this.Week[new Date(timeValue).getDay()];
  }
}

export default angular.module('leptonApp.weeklyDemandReport', [uiRouter, moment, PowerFormatter, DailyMaxDemandPowerService, DemandPowerService, Chart, DateUtil, CsvUtil, CompareWeatherLogic, DailyWeatherService, WeatherService])
  .config(routing)
  .component('weeklyDemandReport', {
    require: {parentComponent: '^demandReportShow'},
    template: require('./weekly_demand_report.html'),
    controller: WeeklyDemandReportController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/demand_report/weekly/weekly_demand_report.component.js